import React, { Fragment, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Nav,
  NavItem,
  Row,
  Col,
  Table,
} from "reactstrap";

import * as yup from "yup";
import { nextFollowupDate, remarks, Status } from "../../../Constant";
import { Breadcrumbs, H3, H5 } from "../../../AbstractElements";
import { NavLink } from "react-bootstrap";
import {
  assignEnquiry,
  assignLead,
  enquiryChangeStatus,
  getStaff,
  getUsers,
  getUsersRole,
  showEnquiry,
  showfollowup,
  showLead,
  showLeadRole,
  statusChangeLead,
  updateLead,
} from "../../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../../Utils/restUtils";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import Typeahead from "../../../CommonElements/TypeAhead";
import Popup from "../../Common/Popup/Popup";
import AddFollowUp from "../Follow-up/AddFollowUp";
// import AddFollowUp from "../Follow-ups/AddFollowUp";
// import AddToLead from "./AddToLead";

const LeadsDetails = () => {
  const [loading, setloading] = useState(false);
  const [EnquiryDetails, setEnquiryDetails] = useState();
  const [searchParams] = useSearchParams();
  const [userOption, setuserOption] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [status, setStatus] = useState("");
  const [expectedValue, setexpectedValue] = useState("");
  const [modal, setModal] = useState(false);
  const [followUps, setFollowUps] = useState([]);

  const enquiryStatusOptions = [
    { label: "Prospect", value: "prospect" },
    { label: "Negotiation", value: "negotiation" },
    { label: "Won", value: "won" },
    { label: "Lost", value: "lost" },
    { label: "Trial Period", value: "free_period" },
  ];
  const enquiryStatusOptions2 = [{ label: "Converted", value: "converted" }];

  const param1 = searchParams.get("id");
  const authState = useSelector((state) => state.auth);
  const navigate = useNavigate();

  //fetch enquiry details
  const getLeadDetails = async () => {
    setloading(true);
    const response = await getDataWithToken(showLead + `?lead_id=${param1}`);
    if (response.status === true) {     
      setEnquiryDetails(response?.data?.data[0]);
      setStatus(response?.data?.data[0]?.stage);
      if (response?.data?.data[0]?.assigned_user_name) {
        if (response?.data?.data[0]?.expected_value) {
          setexpectedValue(response?.data?.data[0]?.expected_value);
        }
        setSelectedStaff({
          label: response?.data?.data[0].assigned_user_name,
          value: response?.data?.data[0]?.user_id,
        });
      }
    } else if (response.status >= 400 && response.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (response.status >= 500 && response.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }

    setloading(false);
  };

  //fetch followUps
  // const handleGetFollowUps = async () => {
  //     setloading(true);
  //     const response = await getDataWithToken(
  //         showFollowUp + `?lead_id=${param1}`
  //     );
  //     if (response.status === true) {
  //         setFollowUps(response?.data?.data)
  //     } else if (
  //         response.status >= 400 &&
  //         response.status <= 405
  //     ) {
  //         navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
  //     } else if (
  //         response.status >= 500 &&
  //         response.status <= 505
  //     ) {
  //         navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
  //     } else {
  //         navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
  //     }

  //     setloading(false);
  // };

  const getStaffList = async () => {
    try {
      const response = await getDataWithToken(getStaff);

      if (response?.data?.data) {
        const options = response.data.data.map((item) => ({
          value: item.id,
          label: `${item.first_name} ${item.last_name}`,
        }));

        setStaffOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //enqiury assign
  const handleAssign = async (value) => {
    setSelectedStaff(value);
    setloading(true);
    const postRequest = {
      user_id: value.value,
      lead_id: param1,
    };
    const response = await postDataWithToken(assignLead, postRequest);

    if (response.status === 200) {
      toast.success(response.data.message);
      getLeadDetails();
    } else if (response.status >= 400 && response.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (response.status >= 500 && response.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }

    setloading(false);
  };

  //enquiry status change
  const handleChanageStatus = async (value) => {
    setloading(true);
    const postRequest = {
      stage: value,
      lead_id: param1,
    };
    const response = await postDataWithToken(
    statusChangeLead,
      postRequest,
    );

    if (response.status === 200) {
      toast.success(response.data.message);
      getLeadDetails();
    } else if (response.status >= 400 && response.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (response.status >= 500 && response.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }

    setloading(false);
  };

  //handle modal
  const handleModal = () => {
    setModal(!modal);
  };

  //update expectedValue
  const handleUpdateExpectedValue = async () => {
    setloading(true);
    const postRequest = {
    //   name: EnquiryDetails.name,
    //   stage: EnquiryDetails?.stage,
      lead_id: param1,
      expected_value: expectedValue,
    };
    const response = await postDataWithToken(
     updateLead,
      postRequest,
    );

    if (response.status === 200) {
      toast.success(response.data.message);
      getLeadDetails();
    } else if (response.status >= 400 && response.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (response.status >= 500 && response.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }

    setloading(false);
  };

  useEffect(() => {
    getLeadDetails();
    getStaffList();
    handleGetFollowUps()
    // userData();
  }, []);

  const handleAddtoCustomer = () => {
    navigate("/subscriptions/company-add", {
      state: {
        userName: EnquiryDetails?.name,
        mobile: EnquiryDetails?.phone,
        email: EnquiryDetails?.email,
        address: EnquiryDetails?.address,
        country_code: EnquiryDetails?.country_code,
        industry_name:EnquiryDetails?.industry_name,
        country:EnquiryDetails?.country,
      },
    });
  };
   const handleGetFollowUps = async () => {
        setloading(true);
        const response = await getDataWithToken(
          showfollowup + `?lead_id=${param1}`
        );
        if (response.status === true) {
            setFollowUps(response?.data?.data)
        } else if (
            response.status >= 400 &&
            response.status <= 405
        ) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (
            response.status >= 500 &&
            response.status <= 505
        ) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }

        setloading(false);
    };
  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="lead Details"
        parent="Lead"
        title="lead Details"
      />
      <Card>
        <CardBody>
          <div>
            <div className="contair">
              <div>
                <div className="p-3">
                  {/* Header Section */}
                  <div className="row mb-4">
                    <div className="col-md-4">
                      <h4 className="fw-bold mb-3" style={{ fontSize: "17px" }}>
                        {EnquiryDetails?.name}
                      </h4>
                      <p className="mb-1 fw-bold">
                      {EnquiryDetails?.country_code}  {EnquiryDetails?.phone  || "N/A"}
                      </p>
                      <p className="mb-0 fw-bold ">
                        {EnquiryDetails?.email || "N/A"}
                      </p>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label text-muted small">
                          Enquiry ID
                        </label>
                        <p className="fw-bold mb-0">
                          {EnquiryDetails?.enquiry_id || "N/A"}
                        </p>
                        <p className="fw-bold mb-0">
                          {EnquiryDetails?.created_at || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label text-muted small">
                        Lead Stage
                      </label>
                      <div className="d-flex gap-2 align-items-center">
                        <select
                          className="form-select"
                          value={status}
                          onChange={(e) => {
                            handleChanageStatus(e.target.value);
                          }}
                          readOnly={EnquiryDetails?.stage === "converted"}
                          onMouseDown={(e) => {
                            if (EnquiryDetails?.stage === "converted")
                              e.preventDefault();
                          }}
                        >
                          {EnquiryDetails?.stage === "converted"
                            ? enquiryStatusOptions2?.map((item) => (
                                <option value={item?.value}>
                                  {item?.label}
                                </option>
                              ))
                            : enquiryStatusOptions?.map((item) => (
                                <option value={item?.value}>
                                  {item?.label}
                                </option>
                              ))}
                        </select>
                        <span className={`badge-${EnquiryDetails?.stage}`}>
                          {EnquiryDetails?.stage}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Details Section */}
                  <div className="row">
                    <div className="col-md-4 mb-4">
                      <div className="mb-3">
                        <label className="form-label text-muted small">
                          State & Country
                        </label>
                        <p className="mb-0 fw-bold">
                          {EnquiryDetails?.state || "N/A"},{" "}
                          {EnquiryDetails?.country || "N/A"}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label text-muted small">
                          City
                        </label>
                        <p className="mb-0 fw-bold">
                          {EnquiryDetails?.city || "N/A"}
                        </p>
                      </div>

                      <div>
                        <label className="form-label text-muted small">
                          Address
                        </label>
                        <p className="mb-1 fw-bold">
                          {EnquiryDetails?.address || "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4 mb-4">
                      <div className="mb-3">
                        <label className="form-label text-muted small">
                          Next Follow-Up date
                        </label>
                        <br />
                        {EnquiryDetails?.next_followup_date ? (
                          <p className="mb-0 badge badge-warning">
                            {EnquiryDetails?.next_followup_date || "N/A"}
                          </p>
                        ) : (
                          <p className="fw-bold">{"N/A"}</p>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label text-muted small">
                          Source
                        </label>
                        <p className="mb-0 fw-bold">
                          {EnquiryDetails?.source || "N/A"}
                        </p>
                      </div>
                      <div>
                        <label className="form-label text-muted small">
                          Note
                        </label>
                        <p className="mb-1 fw-bold">
                          {EnquiryDetails?.notes || "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4 mb-4">
                      <div className="mb-3">
                        <label className="form-label text-muted small">
                          Industry Name
                        </label>
                        <p className=" mb-0 fw-bold">
                          {EnquiryDetails?.industry_name || "N/A"}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label text-muted small">
                          Assigned To
                        </label>
                        <Typeahead
                          options={staffOptions}
                          value={selectedStaff}
                          onChange={(value) => handleAssign(value)}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label text-muted small">
                          Expected Value
                        </label>
                        <div className="d-flex">
                          <input
                            placeholder="Expected Value"
                            value={expectedValue}
                            onChange={(e) => setexpectedValue(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            type="number"
                            className="form-control"
                            name=""
                            id=""
                          />
                          <button
                            className="btn btn-primary mx-2"
                            onClick={() => handleUpdateExpectedValue()}
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                    {EnquiryDetails?.stage == "won" &&
                      EnquiryDetails?.customer_exist === false && (
                        <div className="d-flex justify-content-center">
                          <button
                            onClick={() => handleAddtoCustomer()}
                            className="btn btn-primary"
                          >
                            Add to Customers
                          </button>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <div className="d-flex justify-content-between">
            <H3>Follow-up Timeline</H3>
            <button onClick={handleModal} className="btn btn-primary">
              Add Follow-up +
            </button>
          </div>
        </CardHeader>
        <CardBody>
          <Table>
            <thead>
              <tr>
                {/* <th className='text-center' scope="col">{Id}</th> */}
                <th scope="col">Id</th>
                <th scope="col">Lead ID</th>
                <th scope="col">Followup Date</th>
                <th scope="col">Created By</th>
                <th scope="col">Remarks</th>
                <th scope="col">Next Followup Date</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {followUps?.map((item, index) => (
                <tr key={item?.lead}>
                  {/* <th className='text-center' scope="row">{id + 1}</th> */}
                  <td className="ps-4">{index + 1}</td>
                  <td>{item?.lead}</td>
                  <td>{item?.followup_date}</td>
                  <td>{item?.created_by}</td>
                  <td>{item?.remarks}</td>
                  <td>{item?.next_followup_date}</td>
                  <td className="">
                    <span className={` badge-${item?.status}`}>
                      {item?.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <Popup
        title="Add Follow-up"
        isOpen={modal}
        toggler={handleModal}
        size="lg"
      >
        <AddFollowUp handleGetFollowUps={handleGetFollowUps} getLeadDetails={EnquiryDetails} handleModal={handleModal} authState={authState} leadId={param1} />
      </Popup>
    </Fragment>
  );
};
export default LeadsDetails;
